import gsap from "gsap";
import about from "./about";

export default function kv() {
  scrollAnimation();
  scrollIndicator();
}

function scrollAnimation() {
  const aboutAnimation = about();
  aboutAnimation.pause(0);

  let flag = true;


  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".kv-about-wrap",
        start: "top top",
        end: "+=1800px",
        pin: true,
        scrub: true,
      },
    })
    .to(".section-kv .catch__main span:nth-of-type(1) div", {
      scale: 1,
    })
    .to(".section-kv .catch__main span:nth-of-type(1) div", {
      scale: 3.8,
      rotate: -35,
      duration: 3,
      ease: "power1.in",
    })
    .to(".section-kv .catch__main span:nth-of-type(1)", {
      autoAlpha: 0,
      duration: 1,
      ease: "none",
    }, '-=1')
    .to(
      ".section-kv",
      {
        autoAlpha: 0,
        duration: 1,
        ease: "none",
        onComplete: () => {
          if (flag) {
            aboutAnimation.play(0);
            flag = false;
          }
        },
      }, '-=0.3'
    )
    .from(
      "#scroll-indicator",
      {
        autoAlpha: 0,
        duration: 1,
        ease: "none",
      },
      "<"
    )
    .to(".section-kv", {
      autoAlpha: 0,
      ease: "none",
      duration: 2,
    });
}

function scrollIndicator() {
  gsap
    .timeline({ repeat: -1, repeatDelay: 0.5 })
    .fromTo(
      "#scroll-indicator_kv .scroll-indicator__line-inner",
      {
        yPercent: -100,
      },
      {
        yPercent: 0,
        ease: "quint.out",
        duration: 0.8,
      }
    )
    .to("#scroll-indicator_kv .scroll-indicator__line-inner", {
      yPercent: 100,
      ease: "quint.in",
      duration: 0.8,
    });
}
